export const DEALER_LIST_REQUEST = "DEALER_LIST_REQUEST";
export const DEALER_LIST_SUCCESS = "DEALER_LIST_SUCCESS";
export const DEALER_LIST_FAIL = "DEALER_LIST_FAIL";
